export const DEFAULT_PROFILE_PICTURE_URL =
  'https://s3.amazonaws.com/respondentinc-images/assets/user_avatar_128.png';

export const ERROR_CAUSES = {
  PROJECT_ALREADY_COMPLETED: 'PROJECT_ALREADY_COMPLETED',
} as const;

export const SESSION_TTL_SECONDS = 60 * 60 * 12;
